@if (translationBoot.ready()) {
  <div class="flex h-full">
    <app-env-badge />

    @if (showSidebar) {
      <app-bug-report-button />
      <app-notifications-button />
      <app-sidebar class="z-50" />
    }

    <main
      class="flex-1 overflow-auto [scrollbar-gutter:stable]"
      [ngClass]="{ 'py-4 pl-10 pr-8': addPadding, 'max-md:!px-4 max-md:!pt-2': isCreatorBriefingRoute }"
    >
      <router-outlet />
    </main>
  </div>
} @else if (translationBoot.showLoadingIndicator()) {
  <app-page-loader />
}

@if (appUpdateService.isReloading()) {
  <!--
    Same branded loader as the initial boot-loading screen above. Kept as its own block rather than
    folded into that @if/@else chain, since this one has to overlay on top of already-rendered app
    content too - translationBoot.ready() stays true for the whole time a mid-session update refresh
    (silent or dialog-confirmed) is in flight, so the boot-loading branch above never re-fires for it.
  -->
  <app-page-loader />
}
